<template>
  <div class="badge">
    <i v-if="icon"
       :class="`mdi mdi-${icon}`"></i>

    <p class="badge-text">{{ text }}</p>
  </div>
</template>

<script>
    export default {
        props: {
          text: {
            type: String
          },
          icon: {
            type: String
          }
        },


    }
</script>

<style lang="scss" scoped>
@import "~@variables";

.badge {
  display: flex;
  align-items: center;
  background: $grey-1;
  width: fit-content;
  padding: 0 10px;
  border-radius: 8px;
  font-size: 12px;
  color: $grey-5;

  i {
    margin-right: 5px;
  }

  .badge-text {
    margin: 0;
    // font-weight: 700;
  }
}
</style>
